export default __webpack_public_path__ + "static/media/postions.51139341.svg";